import { addDays, differenceInCalendarDays, format, isSameDay, isSameYear, subDays } from 'date-fns';

export function formatDueLabel(due: Date, hasDueTime: boolean, now = new Date()): string {
	let day: string;
	if (isSameDay(due, now)) {
		day = 'Today';
	} else if (isSameDay(due, addDays(now, 1))) {
		day = 'Tomorrow';
	} else if (isSameDay(due, subDays(now, 1))) {
		day = 'Yesterday';
	} else {
		const distance = differenceInCalendarDays(due, now);
		if (distance > 1 && distance < 7) {
			day = format(due, 'EEEE');
		} else {
			day = isSameYear(due, now) ? format(due, 'MMM d') : format(due, 'MMM d, yyyy');
		}
	}
	return hasDueTime ? `${day}, ${format(due, 'h:mm a')}` : day;
}
